"use client";
import { Download } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useCataloguePDF } from '@/lib/catalogue/useCataloguePDF'
import { siteConfig } from '@/data/siteConfig'
import { cn } from '@/lib/utils'

interface Props {
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link'
  size?: 'default' | 'sm' | 'lg' | 'icon'
  className?: string
  text?: string
}

export function DownloadFullCatalogueButton({ variant = 'outline', size = 'default', className, text = 'Download Catalogue' }: Props) {
  const { generateFullCatalogue, isGenerating } = useCataloguePDF()

  return (
    <Button
      size={size}
      variant={variant}
      className={className}
      onClick={generateFullCatalogue}
      disabled={isGenerating}
    >
      <Download className="mr-2 h-4 w-4" />
      {isGenerating ? 'Preparing...' : text}
    </Button>
  )
}
